import { Card, type CardOptions } from "./card.ts";

export class Timeline extends Card {
  constructor(element: HTMLElement, options: CardOptions) {
    super(element, options);
  }
}

export default function timelineInit() {
  const newsFeedCards = document.querySelectorAll(
    ".timeline__item"
  ) as NodeListOf<HTMLElement>;
  for (let i = 0; i < newsFeedCards.length; i++) {
    new Timeline(newsFeedCards[i], {
      clickable: true,
      ctaClass: "timeline__item-link",
    });
  }
}
